import axios from 'axios';
import { baseUrl } from '../../utils/constants/constants';
import { IndicacaoApiResponse } from './indicacao.types';

export const postIndicacaoVisita = async (codigo: string) => {
	const url = `${baseUrl}v2/Indicacao/Visita`;
	const response = await axios.post<IndicacaoApiResponse<string>>(url, { codigo });
	return response.data;
};
